<breadcrumb-layout>
<breadcrumb-item-view (action)="goToLicenseManagement()">{{'license-management' | translate}}</breadcrumb-item-view>
@if ((breadcrumbStateService.navState$ | async) === States.LICENSE_SEATS_MANAGEMENT) {
  <breadcrumb-item-view>
  <span translate="license-management_seat-management"></span>
</breadcrumb-item-view>
}
</breadcrumb-layout>
